import { Input } from "../../../components/Input/input";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { StyledButton } from "../../../components/Button/button";
import { theme } from "../../../helpers/theme";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ClientUpdate } from "../../../services/clients/edit";
import { GetOperatorClientsById } from "../../../services/clients/getById/types";
import { ToastOptions, toast } from "react-toastify";
import { useEffect} from "react";
import { getOperatorClientsById } from "../../../services/clients/getById";
import { LoadingBackDrop } from "../../../components/loader";

interface BasicFormProps {
  clientData: GetOperatorClientsById[],
  setOperatorClient:(value:GetOperatorClientsById[])=>void,
}

export const BasicForm = ({
  clientData,
  setOperatorClient,
}:BasicFormProps) => {
  const { id } = useParams();
  const cData=clientData[0];

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const EditClientMutation = useMutation(ClientUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });

  const ReGetOperatorClientsByIdMutation = useMutation(getOperatorClientsById, {
    onSuccess: (res) => {
      setOperatorClient(res.data.payload.klienci)
    },
  });


  useEffect(() => {
    if(cData===undefined){
      ReGetOperatorClientsByIdMutation.mutate({
        paginacja: null,
        filtr: {
          id_klient: id,
        },
      })
    }
  }, []);

  const activeValue = (active: Boolean | string) => {
    if (typeof active == "boolean") {
      return active;
    } else {
      return active === "true" ? true : false;
    }
  };

  const validationSchema = yup.object({
    nazwa: yup
      .string()
      .max(50, "Nazwa nie może być dłuższa niż 50 znaków")
      .required("Nazwa jest wymagana"),
    nip: yup
      .number()
      .typeError("Błędny format!")
      .required("NIP jest wymagany")
      .min(1000000000, "NIP musi mieć 10 cyfr")
      .max(9999999999, "NIP musi mieć 10 cyfr"),
    weryfikacja: yup.number().required("Weryfikacja jest wymagana"),
    telefon: yup
      .number()
      .typeError("Błędny format!")
      .required("Telefon jest wymagany")
      .min(100000000, "Telefon musi mieć 9 cyfr")
      .max(999999999, "Telefon musi mieć 9 cyfr"),
    email: yup
      .string()
      .required("Email jest wymagany")
      .email("Błędny format adresu E-mail"),
    info_dodatkowe: yup
      .string()
      .max(100, "Informacje dodatkowe nie mogą być dłuższe niż 100 znaków"),
    aktywny: yup.mixed().required("pole Aktywny jest wymagane jest wymagany"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id_klient: id,
      nazwa: cData?.nazwa?cData?.nazwa:"",
      nip: cData?.nip?cData?.nip:"",
      weryfikacja: cData?.weryfikacja ? cData?.weryfikacja : Number(0),
      telefon: cData?.telefon?cData?.telefon:"",
      email: cData?.email?cData?.email:"",
      info_dodatkowe: cData?.info_dodatkowe?cData?.info_dodatkowe:"",
      aktywny: cData?.aktywny === true ? "true" : "false",
      // adres: cData ? cData.adres_klient.id_klient : null
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_klient: values.id_klient,
        nazwa: values.nazwa,
        nip: values.nip,
        weryfikacja: values.weryfikacja,
        telefon: values.telefon,
        email: values.email,
        info_dodatkowe: values.info_dodatkowe,
        aktywny: activeValue(values.aktywny),
        adres: null,
      };
      EditClientMutation.mutate(body);
    },
  });

  return (
    (cData!==undefined
    ?
    <BasicFormWrapper
      onSubmit={formik.handleSubmit}
   >
      <FormWrapper>
        <Input
          label="Nazwa"
          id="nazwa"
          name="nazwa"
          value={formik.values.nazwa}
          onChange={formik.handleChange}
          error={formik.touched.nazwa && Boolean(formik.errors.nazwa)}
          helperText={formik.touched.nazwa && formik.errors.nazwa}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="NIP"
          id="nip"
          name="nip"
          value={formik.values.nip}
          onChange={formik.handleChange}
          error={formik.touched.nip && Boolean(formik.errors.nip)}
          helperText={formik.touched.nip && formik.errors.nip}
          onBlur={formik.handleBlur}
          variant="filled"
           style={{ marginTop: 11 }}
        />
        <FormControl fullWidth>
          <InputLabel
            sx={{
              fontSize: "14px",
              font: `${theme.fonts.interRegular}`,
              top: "13px",
              left: "0px",
              zIndex: "100",
              "&.Mui-focused": {
                color: `${theme.colors.gray01_secondaryText}`,
              },
            }}
            key="weryfikacja-label"
          >
            Weryfikacja
          </InputLabel>

          <Select
            placeholder="Weryfikacja"
            labelId="weryfikacja-label"
            label="Weryfikacja"
            id="weryfikacja"
            name="weryfikacja"
            disableUnderline
            value={formik.values.weryfikacja}
            onChange={formik.handleChange}
            // error={formik.touched.weryfikacja && Boolean(formik.errors.weryfikacja)}
            // helperText={formik.touched.weryfikacja && formik.errors.weryfikacja}
            onBlur={formik.handleBlur}
            variant="filled"
            sx={{
              width: "100%",
              backgroundColor: "#fcfcfb",
              borderRadius: "8px",
              "& .MuiFilledInput-root": {
                color: `${theme.colors.black_primaryText} `,
                overflow: "hidden",
                borderRadius: 10,
                backgroundColor: "#fcfcfb",
                border: "none",

                "&:hover": {
                  backgroundColor: `${theme.colors.white} `,
                },
                "&.Mui-focused": {
                  backgroundColor: `${theme.colors.gray05_input} `,
                  boxShadow: `rgba(25, 18, 210, 0.25) 0 0 0 2px`,
                  borderColor: `${theme.colors.blue01_active} `,
                },
              },
              "& .MuiFormLabel-root": {
                "&.Mui-focused": {
                  color: `${theme.colors.gray01_secondaryText} `,
                },
              },
              "& .Mui-error": {
                color: `${theme.colors.red01_alert} `,
                // "font-size": "12px",//<<<TODO
              },
            }}
          >
            <MenuItem value={0}>Niezweryfikowany</MenuItem>
            <MenuItem value={1}>Zweryfikowany pozytywnie</MenuItem>
            <MenuItem value={2}>Zweryfikowany negatywnie</MenuItem>
          </Select>
        </FormControl>

        <Input
          label="Telefon"
          id="telefon"
          name="telefon"
          value={formik.values.telefon}
          onChange={formik.handleChange}
          error={formik.touched.telefon && Boolean(formik.errors.telefon)}
          helperText={formik.touched.telefon && formik.errors.telefon}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Email"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Info dodatkowe"
          id="info_dodatkowe"
          name="info_dodatkowe"
          value={formik.values.info_dodatkowe}
          onChange={formik.handleChange}
          error={
            formik.touched.info_dodatkowe &&
            Boolean(formik.errors.info_dodatkowe)
          }
          helperText={
            formik.touched.info_dodatkowe && formik.errors.info_dodatkowe
          }
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <FormLabel id="active-label">Aktywny</FormLabel>
        <RadioGroup
          aria-labelledby="active-label"
          defaultValue="true"
          name="aktywny"
          value={formik.values.aktywny}
          onChange={formik.handleChange}
          // error={formik.touched.aktywny && Boolean(formik.errors.aktywny)}
          // helperText={formik.touched.aktywny && formik.errors.aktywny}
          onBlur={formik.handleBlur}
        >
          <FormControlLabel value="true" control={<Radio />} label="Aktywny" />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="Niekatywny"
          />
        </RadioGroup>

        <StyledButton
          disabled={!formik.isValid || EditClientMutation.isLoading}
          type="submit"
          variant="contained"
        >
          Zapisz
        </StyledButton>
      </FormWrapper>
    </BasicFormWrapper>
    : <LoadingBackDrop loading={true} />)
    )
  };
  
export default BasicForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
